export default {
  strategy: 'prefix',
  locales: [
    {
      code: 'ar',
      name: 'عربي',
      iso: 'ar-OM',
      file: ['default/error/ar.json', 'ar.ts'],
    },
    {
      code: 'en',
      name: 'En',
      iso: 'en-US',
      file: ['default/error/en.json', 'en.ts'],
    },
  ],
  lazy: false,
  langDir: 'locales',
  defaultLocale: 'ar',
  detectBrowserLanguage: {
    useCookie: true,
    cookieKey: 'i18n_redirected',
    redirectOn: 'root', // recommended
  },
  customRoutes: 'config',
  pages: {
    home: {
      en: '/',
      ar: '/',
    },
  },
};
